/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {UserMenu} from '../user-menu/UserMenu'

const AsideUserMenu: FC = () => {
  const {currentUser} = useAuth()
  const displayName =
    currentUser?.userName ||
    currentUser?.username ||
    currentUser?.fullName ||
    currentUser?.fullname ||
    currentUser?.email ||
    ''

  return (
    <>
      <div className='aside-user-card d-flex align-items-center'>
        {/* begin::Wrapper */}
        <div className='aside-user-main d-flex align-items-center min-w-0 flex-grow-1'>
          {/* begin::Avatar */}
          <div className='symbol symbol-circle symbol-40px flex-shrink-0'>
            <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
          </div>
          {/* end::Avatar */}
          {/* begin::User info */}
          <div className='aside-user-info ms-3 min-w-0'>
            <div
              className='aside-user-name fs-6 fw-bolder lh-sm text-truncate'
              title={displayName}
            >
              {displayName}
            </div>
            <span
              className='aside-user-email d-block fs-7 lh-sm text-truncate'
              title={currentUser?.email || ''}
            >
              {currentUser?.email}
            </span>
          </div>
          {/* end::User info */}
        </div>
        {/* end::Wrapper */}

        {/* begin::User menu */}
        <div className='aside-user-actions ms-2 flex-shrink-0'>
          <button
            type='button'
            className='aside-settings-button btn btn-sm btn-icon position-relative'
            data-kt-menu-trigger='click'
            data-kt-menu-overflow='false'
            data-kt-menu-placement='top-end'
            aria-label='Kullanıcı ayarlarını aç'
            title='Kullanıcı ayarları'
          >
            <KTSVG path='/media/icons/duotune/coding/cod001.svg' className='svg-icon-1' />
          </button>
          <UserMenu />
        </div>
        {/* end::User menu */}
      </div>
    </>
  )
}

export {AsideUserMenu}
